// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins);"]);
// Module
exports.push([module.id, "[data-vuetify] .v-image{z-index:0}[data-vuetify] .v-image__image,[data-vuetify] .v-image__placeholder{z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%}[data-vuetify] .v-image__image{background-repeat:no-repeat}[data-vuetify] .v-image__image--preload{filter:blur(2px)}[data-vuetify] .v-image__image--contain{background-size:contain}[data-vuetify] .v-image__image--cover{background-size:cover}", ""]);
// Exports
module.exports = exports;
